import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "section"]

  connect() {
    this.setupScrollSpy()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setupScrollSpy() {
    // スティッキーヘッダーの高さを考慮したrootMargin
    const options = {
      root: null,
      rootMargin: "-80px 0px -50% 0px",
      threshold: 0
    }

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.updateTabStyles(entry.target.id)
        }
      })
    }, options)

    this.sectionTargets.forEach((section) => {
      this.observer.observe(section)
    })
  }

  switch(event) {
    const sectionId = event.currentTarget.dataset.section

    // タブのスタイル切り替え
    this.updateTabStyles(sectionId)

    // セクションへスクロール
    const targetSection = this.sectionTargets.find(section => section.id === sectionId)
    if (targetSection) {
      targetSection.scrollIntoView({ behavior: "smooth", block: "start" })
    }

    // GAイベント送信
    this.trackTabClick(sectionId)
  }

  updateTabStyles(activeSectionId) {
    this.tabTargets.forEach(tab => {
      const icon = tab.querySelector("svg")
      const text = tab.querySelector("span")

      if (tab.dataset.section === activeSectionId) {
        tab.classList.remove("border-transparent", "text-gray-500")
        tab.classList.add("border-red-600", "text-gray-900")
        if (text) {
          text.classList.add("font-medium")
        }
        if (icon) {
          icon.classList.remove("text-gray-500")
          icon.classList.add("text-red-700")
        }
      } else {
        tab.classList.remove("border-red-600", "text-gray-900")
        tab.classList.add("border-transparent", "text-gray-500")
        if (text) {
          text.classList.remove("font-medium")
        }
        if (icon) {
          icon.classList.remove("text-red-700")
          icon.classList.add("text-gray-500")
        }
      }
    })
  }

  trackTabClick(sectionId) {
    if (typeof gtag === "function") {
      gtag("event", `tab_click_${sectionId}`, {
        event_category: "work_history_edit",
        event_label: sectionId
      })
    }
  }
}
